export default "__VITE_ASSET__DiBqBkUw__"